/**
* Nom : rdProtocolList.js
* Description : Ce fichier contient la définition de la page rdProtocolList 
*               Cette page liste les protocols R&D proposés pour tous les équipements à partir d'une modalité d'essais
* Date de création : 4 aout 2026
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { ListFilter } from 'package_ui_ihm/dist'
import { TextFilter } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { Modality } from 'package_ui_ihm/dist'
import { IconStatus } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';
import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
//import { evaluate } from "mathjs";

/* Hook */
import { useState, useEffect } from 'react';
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useFilter } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'
import { function_dPower } from 'package_ui_ihm/dist'


/**
* RdProtocolList : affiche la page qui liste les protocols R&D proposés pour tous les équipements à partir d'une modalité d'essais
*
* Type : page 
*
* Parametres : 
*  None
*/
function RdProtocolList() {

  // Define useState hooks
  const [selectedTreatmentType, setSelectedTreatmentType] = useState(0);
  const [selectedCat, setSelectedCat] = useState(0);
  const [selectedVar, setSelectedVar] = useState(0);
  const [selectedTargetType, setSelectedTargetType] = useState(0);
  const [selectedKeyword, setSelectedKeyword] = useState("");
  const [selectedValidationStatus, setSelectedValidationStatus] = useState(0);
  const [prevCat, setPrevCat] = useState(0);
  const [treatmentTypes, setTreatmentTypes] = useState([])
  const [categories, setCategories] = useState([])
  const [varieties, setVarieties] = useState([])
  const [filteredVarieties, setFilteredVarieties] = useState(varieties);
  const [filteredTrials, setFilteredTrials] = useState([]);
  const [statusTreatmentType, setStatusTreatmentType] = useState(null)
  const [statusCategory, setStatusCategory] = useState(null)
  const [statusVariety, setStatusVariety] = useState(null)
  const [selectedModality, setSelectedModality] = useState(null);
  const [treatmentApplications, setTreatmentApplications] = useState([])
  const [nbTotalRecurrence, setNbTotalRecurrence] = useState(0)
  const [products, setProducts] = useState([])
  const [productVersions, setProductVersions] = useState([])
  const [productReferences, setProductReferences] = useState([])
  const [isDataLoading, setDataLoading] = useState(false)
  const [distances, setDistances] = useState([0])


  // Define useContext hooks
  const { authStatus, authToken } = useAuth();
  const { path } = useApi();
  const { treatmentFilter, setTreatmentFilter } = useFilter();
  const { validationStatus, targetTypes } = useData();


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  function updateFilteredVarieties() {
    // Check category change to reinit variety except at the first loading of page
    if(selectedCat !== prevCat)
    {
      setSelectedVar(0);
      setPrevCat(selectedCat);
    } 
    // Filtering of varieties
    if( selectedCat > 0 )
    {
      setFilteredVarieties(varieties.filter((variety) => variety.category_id === Number(selectedCat)))
    }  
    else
    {
      setFilteredVarieties(varieties)
    }
  }

  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Headers
    const headers = {
      accept: 'application/json',
      Authorization: token,
    }
    // Requests in parallel to win time 
    const [resTreatmentType, resCategory, resVariety, resProduct, resProductVersion] = await Promise.all([
      // Treatment types
      fetch(path + "/api/bo-trty/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Categories
      fetch(path + "/api/bo-cary/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Varieties
      fetch(path + "/api/bo-vaty/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Produits
      fetch(path + "/api/eq-prct/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Versions des produits
      fetch(path + "/api/eq-prve/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
    ])
    // Responses in parallel to win time
    const [dataTreatmentType, dataCategory, dataVariety, dataProduct, dataProductVersion] = await Promise.all([
      resTreatmentType.json(),
      resCategory.json(),
      resVariety.json(),
      resProduct.json(),
      resProductVersion.json(),
    ])
    // Set variables
    setStatusTreatmentType(resTreatmentType.ok)
    setTreatmentTypes(dataTreatmentType["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setStatusCategory(resCategory.ok)
    setCategories(dataCategory["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setStatusVariety(resVariety.ok)
    setVarieties(dataVariety["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setProducts(dataProduct["results"])
    setProductVersions(dataProductVersion["results"])
    // Dataloading
    setDataLoading(false)
  }

  async function retrieveFilteredTrials() {
    // Token
    const token = "Bearer " + authToken
    // Filtered Trials
    var url
    if(selectedKeyword !== "")
    {
      url = path + "/api/bo-tral/?treatment_type_id=" + selectedTreatmentType + "&validation_status_id=" + selectedValidationStatus + "&category_id=" + selectedCat + "&variety_id=" + selectedVar + "&target_type_id=" + selectedTargetType + "&keywords=" + selectedKeyword
    }
    else
    {
      url = path + "/api/bo-tral/?treatment_type_id=" + selectedTreatmentType + "&validation_status_id=" + selectedValidationStatus + "&category_id=" + selectedCat + "&variety_id=" + selectedVar + "&target_type_id=" + selectedTargetType
    }
    const resTr = await fetch(url,  
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const dataTr = await resTr.json();
    const treatment_list = dataTr['results']
    //setTrials(treatment_list)
    setFilteredTrials(treatment_list)
  }

  async function retrieveModalityData() {
    // Token
    const token = "Bearer " + authToken
    // Retrieve treatment applications linked to modality
    const resTreatmentApplication = await fetch(path + "/api/bo-trap/?modality_id=" + selectedModality.id, 
    {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      headers: {
          accept: 'application/json',
          Authorization: token,
      },
    }
    );
    const dataTreatmentApplication = await resTreatmentApplication.json();
    setTreatmentApplications(dataTreatmentApplication["results"])
    // Dataloading
    setDataLoading(false)
  }

  const filterApply = (event) => {
    event.preventDefault();
    retrieveFilteredTrials()
  }

  const filterReset = (event) => {
    event.preventDefault();
    setSelectedTreatmentType(0)
    setSelectedCat(0)
    setSelectedVar(0)
    setSelectedTargetType(0)
    setSelectedKeyword("")
    setSelectedValidationStatus(0)
  }

  const handleSelectItem = (event, itemId) => {
    event.preventDefault();
    setSelectedModality(itemId)
  }

  function compute_modalities_number() {
    var number = 0
    for(const trial of filteredTrials)
    {
      if(trial["modalities"] && trial["modalities"].length !== 0){
        if(Number(selectedValidationStatus) === 0)
        {
          number = number + trial["modalities"].length
        }
        else
        {
          for(const modality of trial["modalities"])
          {
            if(modality.validation_status.id === Number(selectedValidationStatus))
            {
              number = number + 1
            }
          }        
        }
      }
    }
    return number
  }

  function computeTotalRecurrence() {
    var totalRecurrence = 0
    for (const element of treatmentApplications) {
      totalRecurrence += element.nb_recurrence
    }
    setNbTotalRecurrence(totalRecurrence)
  }

  function manageDistances() {
    var treatmentApplicationDistances = []
    for (const element of treatmentApplications) {
      treatmentApplicationDistances.push(element.distance)
    }
    setDistances(treatmentApplicationDistances)
  }

  function setNewDistance(value, index) {
    var newDistances = [...distances]
    newDistances[index] = value
    setDistances(newDistances)
  }

  function function_dose(distance, treatment_parameter) {
    var dPower = function_dPower(treatment_parameter.ptu_type.transfer_function, distance)
    var duration = treatment_parameter.duration
    var pulse_width = treatment_parameter.pulse_width
    var dose = dPower * duration * pulse_width / 100 
    return dose
  }

  function function_duration(distance, modified_distance, treatment_parameter, product_reference) {
    // new duration with original distance
    var new_duration
    new_duration = treatment_parameter.duration * function_dPower(treatment_parameter.ptu_type.transfer_function, distance) / function_dPower(product_reference['ptu_types'][0]['transfer_function'], distance)
    // new duration with modified distance
    var new_duration_following_distance
    new_duration_following_distance = new_duration * function_dPower(product_reference['ptu_types'][0]['transfer_function'], modified_distance) / function_dPower(product_reference['ptu_types'][0]['transfer_function'], distance)
    // arrondi à 2 décimal
    new_duration_following_distance = Number((new_duration_following_distance).toFixed(2))
    return new_duration_following_distance
  }

  function function_delay(distance, modified_distance, treatment_parameter, product_reference) {
    var new_duration = function_duration(distance, modified_distance, treatment_parameter, product_reference)
    var old_duration = treatment_parameter.duration
    var new_delay = treatment_parameter.delay * ( new_duration / old_duration) 
    // arrondi à 2 décimal
    new_delay = Number((new_delay).toFixed(2))
    return new_delay
  }

  async function retrieveProductReference() {
    // Token
    const token = "Bearer " + authToken
    // Products references
    var ref_products = []
    // Product version
    if(productVersions.length !== 0)
    {
      for(const product_version of productVersions)
      {
        const resPtuTypes = await fetch(path + "/api/eq-ptty/?product_id=" + product_version.product.id + "&product_version=" + product_version.name, 
          {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: {
                accept: 'application/json',
                Authorization: token,
            },
          }
        );
        const dataPtuTypes = await resPtuTypes.json();
        ref_products.push({id: ref_products.length, product: product_version.product, version: product_version.name, ptu_types: dataPtuTypes['results']})
      }
    }
    else{
      for(const product of products)
      {
        ref_products.push({id: ref_products.length, product: product, version: '1', ptu_types: []})
      }
    }
    setProductReferences(ref_products)
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
      if(treatmentFilter !== null)
      {
        setSelectedTreatmentType(treatmentFilter['treatment_type_id'])
        setSelectedCat(treatmentFilter['category_id'])
        setSelectedVar(treatmentFilter['variety_id'])
        setSelectedTargetType(treatmentFilter['target_type_id'])
        setSelectedKeyword(treatmentFilter['keywords'])
        setSelectedValidationStatus(treatmentFilter['validation_status']) 
        setTreatmentFilter(null)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {
    updateFilteredVarieties();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varieties, selectedCat])

  useEffect(() => {
    if(selectedModality !== null)
    {
      retrieveModalityData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModality])

  useEffect(() => {
    computeTotalRecurrence()
    manageDistances()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentApplications])

  useEffect(() => {
    if(selectedModality !== null)
    {
      retrieveProductReference()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, productVersions, selectedModality])


  // Render component
  return (
    <div>
      <TabRD tabNumber={3}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusTreatmentType === true && statusCategory === true && statusVariety === true) ? (
              <div>
                <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                {/*Normal size of screen*/}
                  {/*Filtering*/}
                  <div className='flex-rows'>
                    <h3>Filtres</h3>
                    <TextFilter label="Mot clé" value={selectedKeyword} setValue={setSelectedKeyword}></TextFilter>
                    <ListFilter labelText='Type de traitements' choices={treatmentTypes.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType} subfilter={false}/>
                    <ListFilter labelText='Cible - Catégorie' choices={categories.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedCat} setSelectedItem={setSelectedCat} subfilter={false}/>
                    <ListFilter labelText='Cible - Variété' choices={filteredVarieties.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedVar} setSelectedItem={setSelectedVar} subfilter={true}/>
                    <ListFilter labelText='Cible - Type de cible' choices={targetTypes.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedTargetType} setSelectedItem={setSelectedTargetType} subfilter={false}/>
                    <ListFilter labelText='Status de validation' choices={validationStatus} choiceParam={'name'} selectedItem={selectedValidationStatus} setSelectedItem={setSelectedValidationStatus} subfilter={false}/>
                    <div className='grid-2-2-1'>
                      <button onClick={filterApply} className='button-secondary clickable'>Appliquer</button>
                      <button onClick={filterReset} className='button-secondary clickable'>Sans filtres</button>
                    </div>
                  </div>
                  {(screenWidth > 650) ? null : <Divider/>}
                  {/*Trials list*/}
                  <div className='scroll-list-rd'>
                    <h2 className='subtitle'>Nombre de modalités : {compute_modalities_number()}</h2>
                    {/*Display trial/modality list*/}
                    {(filteredTrials && filteredTrials.length !== 0) ? (
                      filteredTrials.sort((a, b) => (a.name > b.name)?1:-1).map((trial) => (
                        (trial.modalities && trial.modalities.length !== 0) ? (
                          trial.modalities.filter(
                            mod => (Number(selectedValidationStatus) !== 0) ? mod.validation_status.id === Number(selectedValidationStatus) : mod
                          ).sort((a, b) => (a.reference > b.reference)?1:-1).map((modality) => (
                            <Item key={trial['id'] + "/" + modality['id']} id={trial['id'] + "/" + modality['id']} selected={(selectedModality !== null && selectedModality['id'] === modality['id']) ? true : false}>
                              <div onClick={(e) => handleSelectItem(e, modality)}>
                                <div className='grid-10-1'>
                                  <h3 className='item-text'>{trial['name'] + "/" + modality['reference'] + " sur " + trial['product']['name'] + " V" + trial["product_version"] }</h3> 
                                  <div className='flex-row justify-end'>
                                    <div/>
                                    <IconStatus color={modality["validation_status"]["color"]}></IconStatus>
                                  </div>
                                </div>
                                <Modality id={modality['id']} modality={modality} product_id={trial['product']['id']} product_version_name={trial["product_version"]} protocole={true}/>
                              </div>
                            </Item>
                          ))
                        ) : (
                          null
                        )
                      ))
                    ) : (
                      <div>
                        <p>Aucune modalité. Essayez de modifier le filtrage !</p>
                        <p>Selectionnez vos filtres et cliquer sur "Appliquer".</p>
                      </div>
                    )}
                  </div>
                </div>
                {/*Protocoles par reference de produit*/}
                <h2 className='subtitle margin-top'>Protocoles par produit</h2>
                {(selectedModality !== null) ? (
                  <div>
                    {(treatmentApplications && treatmentApplications.length !== 0) ? (
                      treatmentApplications.sort((a, b) => (a.application_order > b.application_order)?1:-1).map((treatmentApplication, index) => (
                        <div key={treatmentApplication['id']}>
                          <p className='modality-subtitle'>Régler la distance de la cible (en cm) pour l'application {index + 1} : <input style={{width: 120}} className='form-input margin-left margin-right' type='number' value={distances[index]} onChange={(e) => setNewDistance(e.target.value, index)}/></p>
                        </div>
                      ))
                    ) : (
                      null
                    )}
                    <div className='margin-bottom' />
                    <p className='modality-subtitle'>{nbTotalRecurrence} application(s) avec un intervalle de {selectedModality['application_frequence']} jours</p>
                    <div className='margin-bottom' />
                    {(productReferences && productReferences.length !== 0) ? (
                      productReferences.map((productReference) => (
                        <TableContainer key={productReference.id} className='margin-bottom' component={Paper}>
                          <TableMui sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableBody>
                              <TableRow>
                                <TableCell>{productReference['product']['name']} V{productReference['version']}</TableCell>
                                {(productReference['ptu_types'].length !== 0) ? (
                                  <TableCell>
                                    {(treatmentApplications && treatmentApplications.length !== 0) ? (
                                        treatmentApplications.sort((a, b) => (a.application_order > b.application_order)?1:-1).map((treatmentApplication, index) => (
                                          <div key={treatmentApplication['id']} >
                                            <div className={'application-border grid-1-1-1'}>
                                              <div className='flex-row'>
                                                <p className='modality-subtitle'>Odre d'application : </p>
                                                <p className='modality-text'>{treatmentApplication['application_order']}</p>
                                              </div>
                                              <div className='flex-row'>
                                                <p className='modality-subtitle'>Distance de la cible : </p>
                                                <p className='modality-text'>{distances[index]}</p>
                                              </div>
                                              <div className='flex-row'>
                                                <p className='modality-subtitle'>Nombre de récurrence : </p>
                                                <p className='modality-text'>{treatmentApplication['nb_recurrence']}</p>
                                              </div>
                                            </div>
                                            {/*treatment parameters information*/}
                                              <TableContainer className='margin-bottom' component={Paper}>
                                                <TableMui sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                                  <TableHead>
                                                    <TableRow>
                                                        <TableCell><p className='table-label'>Type de PTU</p></TableCell>
                                                        <TableCell><p className='table-label'>Fréquence (Hz)</p></TableCell>
                                                        <TableCell><p className='table-label'>Rapport cyclique (%)</p></TableCell>
                                                        <TableCell><p className='table-label'>Durée (s)</p></TableCell>
                                                        <TableCell><p className='table-label'>Délai (s)</p></TableCell>
                                                        <TableCell><p className='table-label'>dPuissance (mW/cm²)</p></TableCell>
                                                        <TableCell><p className='table-label'>Dose (mJ/cm²)</p></TableCell>
                                                    </TableRow>
                                                  </TableHead>
                                                  <TableBody>
                                                    {(treatmentApplication['treatment_parameters'] && treatmentApplication['treatment_parameters'] !== 0) ? (
                                                      treatmentApplication['treatment_parameters'].map((treatmentParameter) => (
                                                        <TableRow key={treatmentParameter.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                          <TableCell component="th" scope="row">{productReference['ptu_types'][0]['reference']}</TableCell>
                                                          <TableCell>{treatmentParameter.frequence}</TableCell>
                                                          <TableCell>{treatmentParameter.pulse_width}</TableCell>
                                                          <TableCell>{function_duration(treatmentApplication['distance'], distances[index], treatmentParameter, productReference)}</TableCell>
                                                          <TableCell>{function_delay(treatmentApplication['distance'], distances[index], treatmentParameter, productReference)}</TableCell>
                                                          <TableCell>{function_dPower(productReference['ptu_types'][0]['transfer_function'], distances[index])}</TableCell>{/*dP = f(distance)*/}
                                                          <TableCell>{function_dose(treatmentApplication['distance'], treatmentParameter)}</TableCell>{/*Dose = dPuissance * durée * rapport cyclique*/}
                                                        </TableRow>
                                                      ))
                                                    ) : (
                                                      <div><p className='table-cell-margin'>Aucuns paramètres actuellement. </p></div>
                                                    )}
                                                  </TableBody>
                                                </TableMui>
                                              </TableContainer>
                                            </div>
                                        ))
                                    ) : (
                                        <div><p className='table-cell-margin'>Aucune application de traitement actuellement. </p></div>
                                    )}
                                  </TableCell>
                                ) : (
                                  <TableCell>Aucun type de PTU disponible pour ce produit</TableCell>
                                )}
                              </TableRow>
                            </TableBody>
                          </TableMui>
                        </TableContainer>
                      ))
                    ) : (
                      null
                    )}
                  </div>
                ) : (
                  <p className='modality-text'>Selectionnez une modalité.</p>
                )}
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default RdProtocolList;
